import * as React from 'react';
import { Button as ButtonComponentsV2, ButtonProps as IButtonComponentsV2 } from 'components/v2';

interface IButton extends Omit<IButtonComponentsV2, 'classes'> {}

const Button: React.FunctionComponent<IButton> = (props) => {
  const { children, ...otherProps } = props;

  return (
    <ButtonComponentsV2 color="primary" extraPadding extraRounded fullWidth variant="contained" {...otherProps}>
      {children}
    </ButtonComponentsV2>
  );
};

export default Button;
